import React, { memo, useMemo } from "react";
import EventListenerSummary from "./EventListenerSummary";
import labels from "../helpers/labels";
import Errors from "../../../Components/Errors";

function EventSummary({ state, event, node, engine, addChild }) {
  const eventListeners = useMemo(
    () =>
      [...(state.EventListeners || [])]
        .filter((listener) => listener.EventType === event)
        .sort((a, b) => a.Order - b.Order),
    [event, state.EventListeners]
  );

  return (
    <div
      className="bg-white p-3 bg-opacity-50 my-1"
    >
      <h3 className="my-0">Event: {labels[event] || event}</h3>
      <Errors
        filterFn={(e) =>
          node.options.id === e.workflow?.UUID &&
          e.EventType === event &&
          !e.eventListener?.UUID
        }
      />
      <div>
        {eventListeners.map((eventListener) => (
          <EventListenerSummary
            key={eventListener.UUID}
            eventListener={eventListener}
            node={node}
            engine={engine}
            addChild={addChild}
          />
        ))}
      </div>
    </div>
  );
}

export default memo(EventSummary);
